import styled from 'styled-components';
import colors from 'constants/colors';

export const RowContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: flex-end;
  column-gap: 8px;

  .email, .phone {
    width: 100%;
    position: relative;
  }
`;

export const TravelInputRow = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: 10px 0;
  column-gap: 16px;

  .infos {
    width: 80%;
    display: flex;
    column-gap: 8px;
  }

  @media only screen and (max-width: 767px) {
    flex-direction: column;
    row-gap: 25px;

    .infos {
      width: 100%;
      flex-direction: column;
      row-gap: 25px;
    }
  }

  .mobileRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 50%;
    column-gap: 8px;

    @media only screen and (max-width: 767px) {
      width: 100%;
      column-gap: 10px;
      min-width: 300px;
    }
  }

  span {
    display: block;
    margin-bottom: 7px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 1px;
    color: ${colors.silver};
    white-space: nowrap;

    @media only screen and (max-width: 1200px) {
      font-size: 11px;
    }
  }

  .datePickerContainer {
    width: 55%;
    position: relative;

    .datePlaceHolder {
      position: relative;
      top: 4px;
      left: 10px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.5px;
      color: ${colors.silver};
      white-space: nowrap;
    }
  }
  
  .timePickerContainer {
    width: 45%;
    position: relative;

    .timePlaceHolder {
      position: relative;
      top: 4px;
      left: 10px;
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 0.5px;
      color: ${colors.silver};
      white-space: nowrap;
    }
  }
`;

